/* SAFA V11 · lecteur vidéo, aperçus et vidéo flottante */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function initStory() {
    var modal = $('[data-v11-story]');
    if (!modal) return;
    var video = $('[data-v11-story-video]', modal), bars = $('[data-v11-story-bars]', modal), label = $('[data-v11-story-label]', modal);
    var list = [], idx = 0, last = null;
    function group(el) { var g = el.getAttribute('data-v11-story-group') || ''; return $$('[data-v11-story-src]').filter(function (x) { return (x.getAttribute('data-v11-story-group') || '') === g; }); }
    function drawBars() {
      bars.innerHTML = '';
      list.forEach(function (_, i) { var s = document.createElement('span'); s.appendChild(document.createElement('i')); if (i < idx) s.className = 'is-done'; bars.appendChild(s); });
    }
    function load(i) {
      if (!list.length) return;
      idx = Math.max(0, Math.min(list.length - 1, i));
      var el = list[idx];
      video.src = el.getAttribute('data-v11-story-src');
      var poster = el.getAttribute('data-v11-story-poster');
      if (poster) video.poster = poster; else video.removeAttribute('poster');
      label.textContent = el.getAttribute('data-v11-story-label') || '';
      drawBars();
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.muted = true; video.play().catch(function () {}); });
    }
    function open(el) {
      list = group(el); last = el;
      modal.hidden = false;
      document.body.classList.add('v9-lock');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      video.muted = false;
      load(list.indexOf(el));
    }
    function close() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      video.pause(); video.removeAttribute('src'); video.load();
      document.body.classList.remove('v9-lock');
      setTimeout(function () { modal.hidden = true; }, 200);
      if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) {} }
    }
    function next() { if (idx < list.length - 1) load(idx + 1); else close(); }
    video.addEventListener('timeupdate', function () { var s = bars.children[idx]; if (s && video.duration) s.firstChild.style.width = (video.currentTime / video.duration * 100) + '%'; });
    video.addEventListener('ended', next);
    document.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('[data-v11-story-src]'); if (t) { e.preventDefault(); open(t); } });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-v11-story-close]')) { close(); return; }
      if (e.target.closest('[data-v11-story-next]')) { next(); return; }
      if (e.target.closest('[data-v11-story-prev]')) { load(idx - 1); return; }
      if (e.target.closest('[data-v11-story-toggle]')) { if (video.paused) video.play(); else video.pause(); return; }
      if (e.target.closest('[data-v9-scroll-offer]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') load(idx - 1);
    });
  }

  function initPreviews() {
    var vids = $$('[data-v11-preview]');
    if (!vids.length || !('IntersectionObserver' in window) || reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  function initFloat() {
    var f = $('[data-v11-float]');
    if (!f) return;
    try { if (sessionStorage.getItem('safa_v11_float_off')) return; } catch (e) {}
    var v = $('[data-v11-float-video]', f), openBtn = $('[data-v11-float-open]', f), x = $('[data-v11-float-close]', f);
    f.hidden = false;
    function mini() {
      f.classList.remove('is-expanded');
      v.muted = true; v.loop = true; v.controls = false;
      if (!reduce) v.play().catch(function () {}); else v.pause();
    }
    function expand() {
      f.classList.add('is-expanded');
      v.loop = false; v.muted = false;
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
    }
    mini();
    openBtn.addEventListener('click', function () {
      if (!f.classList.contains('is-expanded')) { expand(); return; }
      if (v.paused) v.play(); else v.pause();
    });
    x.addEventListener('click', function (e) {
      e.stopPropagation();
      if (f.classList.contains('is-expanded')) { mini(); return; }
      v.pause(); f.hidden = true;
      try { sessionStorage.setItem('safa_v11_float_off', '1'); } catch (err) {}
    });
    v.addEventListener('ended', function () { if (f.classList.contains('is-expanded')) mini(); });
    f.addEventListener('click', function (e) { if (e.target.closest('[data-v9-scroll-offer]')) mini(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && f.classList.contains('is-expanded')) mini(); });
  }

  function init() { initStory(); initPreviews(); initFloat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', initPreviews);
})();
